import { useAuth } from "./AuthContext";

/** Section levels are issued by the server together with action permissions.
 * They never replace a record's scope, lifecycle or approval checks. */
export function useSectionAccess(section: string) {
  const { hasPermission } = useAuth();
  return {
    canRead: hasPermission(`section:${section}:read`),
    canWrite: hasPermission(`section:${section}:write`),
    canFull: hasPermission(`section:${section}:full`),
  };
}
